/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class MetalSelectGrid extends _Ext.GridBase<OMS.ProductMasterRow, any> {
        protected getColumnsKey() { return 'OMS.ProductMaster'; }
        protected getDialogType() { return <any>OMS.ProductMasterDialog; }
        protected getIdProperty() { return OMS.ProductMasterRow.idProperty; }
        protected getLocalTextPrefix() { return OMS.ProductMasterRow.localTextPrefix; }
        protected getService() { return OMS.MetalProductsService.baseUrl; }
        //protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }
        //protected getInsertPermission() { return ProductMasterRow.insertPermission; }
        //protected getUpdatePermission() { return ProductMasterRow.updatePermission; }
        //protected getDeletePermission() { return ProductMasterRow.deletePermission; }
        //protected useViewMode() { return true; }
        
        constructor(container: JQuery,options) {
            super(container,options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);

            (this.view.params as ProductRequest).KaratId = options.GridFilters.KaratId;
            (this.view.params as ProductRequest).MetalColorId = options.GridFilters.MetalColorId;
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 });


            return this;
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);



            return grid;
        }

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): OMS.ProductMasterRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            return true;

        }

    }
     
}